export const LEAD_FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "long_text", label: "Long text" },
  { value: "number", label: "Number" },
  { value: "currency", label: "Currency" },
  { value: "checkbox", label: "Checkbox" },
  { value: "single_select", label: "Single select" },
  { value: "multi_select", label: "Multiple select" },
  { value: "date", label: "Date" },
  { value: "datetime", label: "Date and time" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "url", label: "URL" },
  { value: "user", label: "Team member" },
  { value: "file", label: "File or document" },
];

export const SELECT_FIELD_TYPES = new Set(["single_select", "multi_select"]);

export const NUMBER_FIELD_TYPES = new Set(["number", "currency"]);
export const TEXT_FIELD_LIMITS = { text: 2000, long_text: 20000, email: 254, phone: 21, url: 2048 };

export function validationRuleKeys(type) {
  if (NUMBER_FIELD_TYPES.has(type)) return ["min", "max"];
  if (TEXT_FIELD_LIMITS[type]) return ["min_length", "max_length", "pattern"];
  return [];
}

export function fieldInputConstraints(type, rules = {}) {
  if (NUMBER_FIELD_TYPES.has(type)) return { min: rules.min ?? undefined, max: rules.max ?? undefined, step: "any" };
  if (TEXT_FIELD_LIMITS[type]) return {
    minLength: rules.min_length ?? undefined,
    maxLength: Math.min(rules.max_length ?? TEXT_FIELD_LIMITS[type], TEXT_FIELD_LIMITS[type]),
  };
  return {};
}

export function normalizeOptions(options = []) {
  return options.map((option) => {
    if (option && typeof option === "object") {
      return { value: String(option.value ?? option.label ?? ""), label: String(option.label ?? option.value ?? "") };
    }
    return { value: String(option), label: String(option) };
  }).filter((option) => option.value);
}

export function fieldTypeLabel(type) {
  return LEAD_FIELD_TYPES.find((item) => item.value === type)?.label || type;
}

export function leadCustomValue(lead, key) {
  if (lead?.custom_fields && Object.prototype.hasOwnProperty.call(lead.custom_fields, key)) {
    return lead.custom_fields[key];
  }
  return lead?.custom_field_values?.find((item) => item.key === key)?.value ?? null;
}

export function formatLeadFieldValue(field, value, user = null) {
  if (value === null || value === undefined || value === "") return "—";
  if (field?.field_type === "checkbox") return value ? "Yes" : "No";
  if (field?.field_type === "multi_select") return Array.isArray(value) ? value.join(", ") : String(value);
  if (field?.field_type === "currency") {
    const number = Number(value);
    return Number.isFinite(number) ? number.toLocaleString(undefined, { maximumFractionDigits: 2 }) : String(value);
  }
  if (field?.field_type === "number") return Number(value).toLocaleString();
  if (["date", "datetime"].includes(field?.field_type)) {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return field.field_type === "date"
        ? date.toLocaleDateString()
        : date.toLocaleString();
    }
  }
  if (field?.field_type === "user" && user?.name) return user.name;
  if (field?.field_type === "file" && typeof value === "object") return value.name || value.url || value.id || "Document";
  return String(value);
}

export function groupLeadFields(fields = []) {
  return fields.reduce((groups, field) => {
    const section = field.section || "Additional information";
    if (!groups[section]) groups[section] = [];
    groups[section].push(field);
    return groups;
  }, Object.create(null));
}

export function inputValueForField(field, value) {
  if (field.field_type === "multi_select") return Array.isArray(value) ? value : [];
  if (field.field_type === "checkbox") return Boolean(value);
  if (field.field_type === "datetime" && value) return String(value).slice(0, 16);
  return value ?? "";
}
